// A Rendszer képernyők kérései viszik az `X-Platform-View` fejlécet: belépve, Global állásban a szerver ezeket úgy
// futtatja, mint belépés nélkül, tehát ugyanazt adják, amit a global admin kívülről látna. Az intézményi adatot mutató
// Rendszer-listák (`meta.tenantData`) csak olvasva: az ott indított írás a belépett intézményé.
let mode = null;

export function trackPlatformRoute(route) {
    mode = route?.matched?.[1]?.meta?.type === 'global' ? (route.meta?.tenantData ? 'read' : 'all') : null;
}

export function sendsPlatformView(method) {
    return mode === 'all' || (mode === 'read' && ['get', 'head'].includes(String(method || 'get').toLowerCase()));
}
